import { CommandListFeatureFlags } from "./commands/cmdListFeatureFlags";

export class FeatureFlagService {
  /** Every feature flag for the signed-in user. Read once per page load -- see useFeatureFlag. */
  async listFeatureFlags() {
    const cmd = new CommandListFeatureFlags();
    return await cmd.run();
  }
}
